import { useAtomValue } from "jotai";
import { AIMContextViewAtom } from "../state/context.state";
import { DeltaLineagePanel } from "../panels/DeltaLineagePanel";
import { InvestmentCriteriaDrawer } from "./InvestmentCriteriaDrawer";
import { LineagePanel } from "./LineagePanel";
import { FinanceLabMetricTable } from "./FinanceLabMetricTable";
import { AIMViewType } from "../InvestmentMemo.types";
import { DataSourcesPanel } from "../panels/DataSourcesPanel";

export function AIMContextPanel() {
    const AIMContextView = useAtomValue(AIMContextViewAtom);

    if (AIMContextView?.type === AIMViewType.DATA_SOURCES_SETTINGS) {
        return <DataSourcesPanel />;
    }

    if (AIMContextView?.type === AIMViewType.DELTA_LINEAGE) {
        return <DeltaLineagePanel {...AIMContextView.props} />;
    }

    if (AIMContextView?.type === AIMViewType.INVESTMENT_CRITERIA) {
        return <InvestmentCriteriaDrawer />;
    }

    if (AIMContextView?.type === AIMViewType.VALUE_LINEAGE) {
        return <LineagePanel {...AIMContextView} />;
    }

    if (AIMContextView?.type === AIMViewType.LABS_LINEAGE) {
        return <FinanceLabMetricTable {...AIMContextView} />;
    }

    return null;
}
